// src/pages/offlineSales/customerDisplay/customerDisplayChannel.js
// Terminal ⇄ customer display sync over BroadcastChannel (same browser, same origin — no server).
//
// Messages:
//   display → terminal  { type: 'hello' }            display just opened, wants the current state
//   terminal → display  { type: 'state', state }      full snapshot, sent on every change
//
// state.mode: 'idle' (empty cart) | 'cart' (sale in progress) | 'paid' (sale completed, receipt open)

export const getCustomerDisplayChannelName = (shopId) => `bn-customer-display-${shopId}`;

export const CUSTOMER_DISPLAY_WINDOW_NAME = 'bn-customer-display';

export const getCustomerDisplayUrl = (shopId) =>
  `${window.location.origin}/offline-sales/customer-display/${shopId}`;
